/** KAN-670: справочник продавцов Telegram-аккаунтов: список и изменения. */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { telegramSellersApi } from '@/services/api/telegramSellers';
import type { TelegramSellerBody } from '@/types/telegramSeller';

export const TELEGRAM_SELLERS_QUERY_KEY = ['telegram-sellers'] as const;

export function useTelegramSellers() {
  return useQuery({
    queryKey: TELEGRAM_SELLERS_QUERY_KEY,
    queryFn: telegramSellersApi.list,
    staleTime: 30_000,
  });
}

/** Мутация, после которой обновляются справочник и список аккаунтов (там карточка продавца). */
function useInvalidatingMutation<TArgs, TResult>(fn: (args: TArgs) => Promise<TResult>) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: TELEGRAM_SELLERS_QUERY_KEY });
      client.invalidateQueries({ queryKey: ['telegram-accounts'] });
    },
  });
}

export function useTelegramSellerMutations() {
  return {
    create: useInvalidatingMutation((data: TelegramSellerBody) => telegramSellersApi.create(data)),
    update: useInvalidatingMutation((args: { id: string; data: TelegramSellerBody }) =>
      telegramSellersApi.update(args.id, args.data)
    ),
    remove: useInvalidatingMutation((id: string) => telegramSellersApi.remove(id)),
  };
}
